import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useOneIPlanningMechanicsQuery = (dealerLocationIds: number[] | undefined) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.oneIPlanningMechanics,
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: (dealerLocationIds && dealerLocationIds[0]) ?? 0 }, baseUrl)).data.onei_planning_monteurs,
    enabled: !!dealerLocationIds && dealerLocationIds.length > 1
  });
